module.exports = __webpack_public_path__ + "static/media/new6-mob.ec813b43.png";